import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Tooltip
} from "@mui/material";
import { message } from "antd";
import { Fragment, useEffect, useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import { toast, ToastContainer } from "react-toastify";
import axios from "../api";
import Logo from "../assets/DocIT_Logo.jpeg";
import "../styles/UndertakingForm.css";
import { useNavigate } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function UndertakingForm() {
  const date = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    address: "",
    EmpName: "",
    EmpID: "",
    Username: "",
    Manager: "",
    Department: "",
    Title: "",
    City: "",
    State: "",
    Country: "",
    Zip: "",
    assetId: "",
    serialNumber: "",
    accessories: [],
    Model: "",
    ModelNo: "",
    Manufacturer: "",
    Specifications: "",
    AccessoriesExtra: "",
    Receivedby: "",
    idProofFile: null,
    signatureFile: null,
    assetImages: [],
    termsAccepted: false,
    date,
  });
  const validateEmail = (email) => {
    console.log("email", email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
const specificationsList = [

  "i3, 8GB, 256GB SSD",

  "i5, 8GB, 256GB SSD",

  "i7, 8GB, 256GB SSD",

  "i3, 16GB, 512GB SSD",

  "i5, 16GB, 512GB SSD",

  "i7, 16GB, 512GB SSD",

];
  const validateFileType = (file) => {
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    const fileExtension = file.name
      .toLowerCase()
      .substring(file.name.lastIndexOf("."));
    const pdfExtensions = [".pdf"];

    if (
      file.type === "application/pdf" ||
      pdfExtensions.includes(fileExtension)
    ) {
      return {
        isValid: false,
        error: "PDF files are not allowed. Please upload an image file.",
      };
    }

    if (!allowedTypes.includes(file.type)) {
      return {
        isValid: false,
        error: "Only image files (JPEG, PNG, GIF, WebP) are allowed.",
      };
    }

    return { isValid: true, error: null };
  };
  const [errors, setErrors] = useState({});
  const [settings, setSettings] = useState(null);
  const [signatureType, setSignatureType] = useState("upload");
  const signaturePadRef = useRef(null);
  const [openTerms, setOpenTerms] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    message.info("Loading form...");
    // Get location
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLatitude(pos.coords.latitude);
        setLongitude(pos.coords.longitude);
      },
      (err) => console.error("Geolocation error:", err)
    );

    // Get IP address (external service is configurable)
    const ipLookupUrl =
      process.env.REACT_APP_IP_LOOKUP_URL || "https://api.ipify.org?format=json";
    fetch(ipLookupUrl)
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch((err) => console.error("IP fetch error:", err));

    const emailParam = new URLSearchParams(window.location.search).get("email");
    if (emailParam) setFormData((prev) => ({ ...prev, email: emailParam }));

    // Load org-specific branding / form configuration
    axios
      .get("/settings")
      .then((res) => setSettings(res.data.result))
      .catch((err) => console.error("Settings fetch error:", err));
  }, []);
  // const handleChange = (e) => {
  //   const { name, value, files, type, checked } = e.target;
  //   if (errors[name]) {
  //     setErrors((prev) => ({ ...prev, [name]: "" }));
  //   }
  //   if (type === "file") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: name === "assetImages" ? files : files[0],
  //     }));
  //   } else if (type === "checkbox") {
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }
  //   // Validate email on change
  //   if (name === "email" && value && !validateEmail(value)) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       email: "Please enter a valid email address",
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (type === "file") {
      if (files && files.length > 0) {
        if (name === "assetImages") {
          for (let i = 0; i < files.length; i++) {
            const validation = validateFileType(files[i]);
            if (!validation.isValid) {
              setErrors((prev) => ({ ...prev, [name]: validation.error }));
              toast.error(validation.error);
              return;
            }
          }
        } else {
          const validation = validateFileType(files[0]);
          if (!validation.isValid) {
            setErrors((prev) => ({ ...prev, [name]: validation.error }));
            toast.error(validation.error);
            return;
          }
        }
      }

      setFormData((prev) => ({
        ...prev,
        [name]: name === "assetImages" ? files : files[0],
      }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (name === "email") {
      if (value && !validateEmail(value)) {
        setErrors((prev) => ({
          ...prev,
          email: "Please enter a valid email address",
        }));
      } else if (
        value.endsWith("@gmail.com") ||
        value.endsWith("@hotmail.com") ||
        value.endsWith("@outlook.com") ||
        value.endsWith("@yahoo.com")
      ) {
        setErrors((prev) => ({
          ...prev,
          email: "Only organization email IDs are allowed",
        }));
        toast.error("Gmail/Yahoo IDs are not allowed. Please use your official organization Email ID.");
      }
    }
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    try {
      e.preventDefault();

      const newErrors = {};

      if (
        formData.email.endsWith("@gmail.com") || 
        formData.email.endsWith("@yahoo.com") ||
        formData.email.endsWith("@hotmail.com") ||
        formData.email.endsWith("@outlook.com")
      ) {
        newErrors.email = "Only organization email IDs are allowed";
        toast.error("Gmail/Yahoo IDs are not allowed. Please use your official organization Email ID.");
      }

      if (!formData.termsAccepted) {
        return toast.warning("Please accept the terms and conditions.");
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        toast.error("Please fix the validation errors before submitting.");
        return;
      }

      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (key === "assetImages") {
          for (let file of formData.assetImages)
            data.append("assetImages", file);
        } else {
          data.append(key, formData[key]);
        }
      });

      data.append("latitude", latitude);
      data.append("longitude", longitude);
      data.append("ipAddress", ipAddress);

      if (signatureType === "draw" && signaturePadRef.current) {
        if (signaturePadRef.current.isEmpty()) {
          return toast.warning("Please draw your signature.");
        }
        const url = signaturePadRef.current.toDataURL("image/png");
        const blob = await (await fetch(url)).blob();
        data.set(
          "signatureFile",
          new File([blob], "signature.png", { type: "image/png" })
        );
      }

      await axios.post("/undertaking/submit", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Form submitted successfully!");
      navigate("/thank-you");
    } catch (err) {
      console.error(err);
      if (
        err.response?.status === 400 &&
        err.response?.data?.error.includes("already submitted")
      ) {
        toast.error("You have already submitted the form with this email.");
      } else {
        toast.error(
          err.response?.data?.error ||
            "Submission failed. Please check your inputs and try again."
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const renderTextField = (name, label, required = false, type = "text") => (
    <Grid item xs={12} sm={6}>
      <TextField
        name={name}
        label={label}
        type={type}
        value={formData[name] || ""}
        onChange={handleChange}
        fullWidth
        required={required}
        error={!!errors[name]}
        helperText={errors[name]}
      />
    </Grid>
  );

  // Org-configurable values (fall back to defaults until settings load)
  const manufacturersOptions =
    settings?.formOptions?.manufacturers?.length
      ? settings.formOptions.manufacturers
      : ["Dell", "HP", "Lenovo", "Acer", "Asus", "Apple", "MSI", "Samsung", "Microsoft"];
  const accessoriesOptions =
    settings?.formOptions?.accessories?.length
      ? settings.formOptions.accessories
      : [
          "Charger",
          "Bag",
          "Mouse",
          "Headphones",
          "External Monitor",
          "Monitor Cable",
          "Keyboard",
        ];
  const specificationsOptions =
    settings?.formOptions?.specifications?.length
      ? settings.formOptions.specifications
      : specificationsList;
  const termsOptions =
    settings?.terms?.length ? settings.terms : null;
  const companyLegalName =
    settings?.pdf?.footerName ||
    settings?.company?.legalName ||
    "DOCIT SYRL INDIA (OPC) PRIVATE LIMITED";
  const companyAddress =
    settings?.company?.address ||
    settings?.pdf?.footerAddress ||
    "Brigade Triumph, 2nd Floor, Dasarahalli Main Rd, Sector B, Hebbal, Bengaluru 560092";
  const appTitle = settings?.app?.appName || "Asset Undertaking Form";
  const logoSrc =
    settings?.company?.logoUrl && /^https?:\/\//.test(settings.company.logoUrl)
      ? settings.company.logoUrl
      : Logo;

  return (
    <>
      <Container style={{ border: "1px solid #8db8ea" }} maxWidth="md">
        <Paper elevation={4} className="form-wrapper">
          <div
            className="logo"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px",
            }}
          >
            <img
              src={logoSrc}
              alt="Logo"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              height: "100px",
              marginTop: "-5%",
              paddingBottom: "10px",
            }}
          >
            <Typography
              className="asset-text"
              variant="h4"
              style={{ textAlign: "center", fontFamily: "Times New Roman" }}
            >
              {appTitle}
            </Typography>
          </div>

        <form onSubmit={handleSubmit}>
          <Typography variant="h6" style={{ fontFamily: "Times New Roman" }}>
            Employee Info
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <div
            className="employee-info-wrapper"
            style={{ fontFamily: "Times New Roman" }}
          >
            <Grid container spacing={2}>
              {renderTextField("EmpName", "Employee Name", true)}
              {renderTextField("EmpID", "Employee ID", true)}
              {renderTextField("Department", "Department")}
              {renderTextField("Title", "Title")}
              {renderTextField("address", "Address", true)}
              {renderTextField("phone", "Phone", true)}
              {renderTextField("email", "Official Email", true)}
              {renderTextField("Manager", "Manager")}
              {renderTextField("City", "City")}
              {renderTextField("State", "State")}
              {renderTextField("Country", "Country")}
              {renderTextField("Zip", "Zip")}
            </Grid>
          </div>

            <Typography
              variant="h6"
              sx={{ mt: 4 }}
              style={{ fontFamily: "Times New Roman" }}
            >
              Asset Details
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              {renderTextField("assetId", "Asset ID", true)}
              <Grid item xs={12} sm={6} style={{ display: "flex", alignItems: "center" }}>
                <TextField
                  name="serialNumber"
                  label="Serial Number"
                  value={formData.serialNumber || ""}
                  onChange={handleChange}
                  fullWidth
                  required
                  error={!!errors.serialNumber}
                  helperText={errors.serialNumber}
                />
                <Tooltip
                  title={
                    <Box sx={{ p: 0.5, maxWidth: 320 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                        Windows 11 — find serial number
                      </Typography>
                      <Typography variant="caption" display="block">
                        1. Start → type powershell → open Windows PowerShell
                      </Typography>
                      <Typography variant="caption" display="block" sx={{ mb: 0.5 }}>
                        2. Run:
                      </Typography>
                      <Typography
                        variant="caption"
                        component="code"
                        sx={{
                          fontFamily: "monospace",
                          display: "block",
                          bgcolor: "rgba(255,255,255,0.12)",
                          p: 0.75,
                          borderRadius: 0.5,
                          wordBreak: "break-all",
                        }}
                      >
                        Get-WmiObject win32_bios | Select-Object SerialNumber
                      </Typography>
                      <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                        3. Read the serial number from the list on screen.
                      </Typography>
                    </Box>
                  }
                  placement="right"
                  arrow
                >
                  <span style={{ marginLeft: "8px", cursor: "pointer" }}>
                    <InfoOutlinedIcon color="primary" 
                      style={{

                      }}
                    />
                  </span>
                </Tooltip>
              </Grid>

              {renderTextField("Model", "Model")}
              <TextField
                name="Manufacturer"
                label="Manufacturer"
                value={formData.Manufacturer}
                placeholder="Select Manufacturer"
                onChange={handleChange}
                select
                halfWidth
                required
                style={{ width: "28.7%" }}
              >
                {manufacturersOptions.map((company) => (
                  <MenuItem key={company} value={company}>
                    {company}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                name="accessories"
                label="Accessories"
                value={formData.accessories}
                placeholder="Select Accessories"
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "accessories",
                      value:
                        typeof e.target.value === "string"
                          ? e.target.value.split(",")
                          : e.target.value,
                    },
                  })
                }
                select
                SelectProps={{ multiple: true }}
                required
                style={{ width: "28%" }}
              >
                {accessoriesOptions.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
              {/* <TextField
                name="Specifications"
                label="Specifications"
                value={formData.Specifications}
                placeholder="Select Specifications"
                onChange={handleChange}
                select
                halfWidth
                required
                style={{ width: "29.1%" }}
              >
                {[
                  "i3, 8GB, 256GB SSD",
                  "i5, 8GB, 256GB SSD",
                  "i7, 8GB, 256GB SSD",
                  "i3, 16GB, 512GB SSD",
                  "i5, 16GB, 512GB SSD",
                  "i7, 16GB, 512GB SSD",
                ].map((company) => (
                  <MenuItem key={company} value={company}>
                    {company}
                  </MenuItem>
                ))}
              </TextField> */}
 

 
<Autocomplete

  freeSolo // allows manual typing

  options={specificationsOptions}

  value={formData.Specifications || ""}

  onChange={(event, newValue) => {

    setFormData({ ...formData, Specifications: newValue });

  }}

  onInputChange={(event, newInputValue) => {

    setFormData({ ...formData, Specifications: newInputValue });

  }}

  renderInput={(params) => (
<TextField

      {...params}

      name="Specifications"

      label="Specifications"

      placeholder="Select or type Specifications"

      required

      style={{ width: "300px" }}

    />

  )}

/>

              {renderTextField("Receivedby", "Received By", true)}
            </Grid>

            <Typography
              variant="h6"
              sx={{ mt: 4 }}
              style={{ fontFamily: "Times New Roman" }}
            >
              Uploads
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid item xs={12} sm={6}>
              <Box className="upload-box">
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ fontFamily: "Times New Roman" }}
                >
                  ID Proof (Images only)
                </Typography>
                <label htmlFor="idProofFile" className="upload-label">
                  Choose File
                  <input
                    type="file"
                    id="idProofFile"
                    name="idProofFile"
                    accept="image/*"
                    onChange={handleChange}
                    className="upload-input"
                  />
                </label>
                {formData.idProofFile && <p>{formData.idProofFile.name}</p>}
                {errors.idProofFile && (
                  <Typography color="error" variant="caption">
                    {errors.idProofFile}
                  </Typography>
                )}
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box className="upload-box">
                <Typography
                  variant="subtitle1"
                  style={{ fontFamily: "Times New Roman" }}
                  gutterBottom
                >
                  Asset Images (Images only)
                </Typography>
                <label htmlFor="assetImages" className="upload-label">
                  Choose Files
                  <input
                    type="file"
                    id="assetImages"
                    name="assetImages"
                    accept="image/*"
                    multiple
                    onChange={handleChange}
                    className="upload-input"
                  />
                </label>
                {formData.assetImages?.length > 0 && (
                  <p>
                    {Array.from(formData.assetImages)
                      .map((f) => f.name)
                      .join(", ")}
                  </p>
                )}
                {errors.assetImages && (
                  <Typography color="error" variant="caption">
                    {errors.assetImages}
                  </Typography>
                )}
              </Box>
            </Grid>

            <Typography
              variant="h6"
              style={{ fontFamily: "Times New Roman" }}
              sx={{ mt: 4 }}
            >
              Signature
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <FormControl component="fieldset">
              <FormLabel component="legend">Signature Type</FormLabel>
              <RadioGroup
                row
                value={signatureType}
                onChange={(e) => setSignatureType(e.target.value)}
              >
                <FormControlLabel
                  value="upload"
                  control={<Radio />}
                  label="Upload"
                />
                <FormControlLabel
                  value="draw"
                  control={<Radio />}
                  label="Draw"
                />
              </RadioGroup>
            </FormControl>

            {signatureType === "upload" && (
              <Grid item xs={12}>
                <Box
                  className="upload-box"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexDirection: "column" }}
                >
                  <Typography
                    variant="subtitle1"
                    style={{ fontFamily: "Times New Roman" }}
                    gutterBottom
                  >
                    Upload Signature
                  </Typography>
                  <label htmlFor="signatureFile" className="upload-label">
                    Choose File
                    <input
                      type="file"
                      id="signatureFile"
                      name="signatureFile"
                      accept="image/*"
                      onChange={handleChange}
                      className="upload-input"
                    />
                  </label>
                  {formData.signatureFile && (
                    <p>{formData.signatureFile.name}</p>
                  )}
                </Box>
              </Grid>
            )}
            {signatureType === "draw" && (
              <Box mt={2}>
                <SignaturePad
                  ref={signaturePadRef}
                  canvasProps={{ width: 500, height: 200 }}
                  style={{ border: "1px solid #000", borderRadius: 8 }}
                />
                <Button
                  variant="outlined"
                  onClick={() => signaturePadRef.current.clear()}
                  sx={{ mt: 1 }}
                >
                  Clear Signature
                </Button>
              </Box>
            )}
            <Dialog
              open={openTerms}
              onClose={() => setOpenTerms(false)}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle style={{ fontFamily: "Times New Roman" }}>
                Terms and Conditions
              </DialogTitle>
              <DialogContent dividers>
                <Typography
                  variant="body2"
                  style={{ fontFamily: "Times New Roman" }}
                  gutterBottom
                >
                  Please read the following terms carefully:
                  <br />
                  <br />
                  {termsOptions ? (
                    termsOptions.map((line, i) => (
                      <Fragment key={i}>
                        {i + 1}. {line}
                        <br />
                      </Fragment>
                    ))
                  ) : (
                    <>
                      1. This laptop/desktop is a company's asset and should be
                      used for official purposes only.
                      <br />
                      2. Please maintain this asset in good condition.
                      <br />
                      3. Report any issue to IT team.
                      <br />
                      4. Employees may not take the System (Laptop / Desktop /
                      Etc.) for repair to any external agency or vendor
                      with/without IT approval.
                      <br />
                      5. Unauthorized software is not permitted.
                      <br />
                      6. Scan for viruses at least once every 15 days.
                      <br />
                      7. Company data must remain confidential.
                      <br />
                      8. Return the Asset during separation from the company.
                      <br />
                      9. Employee is liable for any misuse or damage.
                      <br />
                      10. In case of loss or theft, full cost recovery is
                      applicable.
                      <br />
                      11. The organization reserves the right to deduct the same
                      from salary or dues.
                      <br />
                    </>
                  )}
                </Typography>
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpenTerms(false)} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            <Box mt={4}>
              <Box display="flex" alignItems="center">
                <Checkbox
                  checked={formData.termsAccepted}
                  onChange={handleChange}
                  name="termsAccepted"
                />
                <Typography
                  variant="h6"
                  sx={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "blue",
                  }}
                  onClick={() => setOpenTerms(true)}
                  style={{ fontFamily: "Times New Roman" }}
                >
                  I Agree The Terms and Conditions
                </Typography>
              </Box>
              <Typography
                variant="body2"
                style={{ fontFamily: "Times New Roman" }}
              >
                Location: Lat {latitude || "--"}, Long {longitude || "--"} | IP:{" "}
                {ipAddress || "--"}
              </Typography>
              <Button
                onClick={() => "antd is working"}
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                sx={{ mt: 2, minWidth: 120 }}
              >
                {isSubmitting ? (
                  <>
                    <CircularProgress
                      size={16}
                      color="inherit"
                      sx={{ mr: 1 }}
                    />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
              <br />
              <br />
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" style={{ textAlign: "center" }}>
                <strong style={{ fontFamily: "Times New Roman" }}>
                  {companyLegalName} <br />
                </strong>
                <span style={{ fontFamily: "Times New Roman" }}>
                  {companyAddress}
                </span>
              </Typography>
            </Box>
          </form>
        </Paper>
        <ToastContainer position="top-center" autoClose={2000} />
      </Container>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitting}
      >
        <CircularProgress color="inherit" size={60} />
        <Typography variant="h6" style={{ fontFamily: "Times New Roman" }}>
          Submitting your form...
        </Typography>
      </Backdrop>
    </>
  );
}

export default UndertakingForm;
